module.exports = __webpack_public_path__ + "static/media/Skatteetatenlogo.93fceca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Skatteetatenlogo.png
// module id = 5752
// module chunks = 0